import { StorageService } from './../Storage/storage.service';
import { reduxExtentionHelper } from './../../shared/helpers/ReduxExtentionHelper';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import * as AppStateAction from './app-state.action';
import { IAppState } from '../../models/AppState';
import { SiteHeaderType } from '../../models/SiteHeaderType';

// export enum SiteHeaderType {
//   LocalHeader,
//   WWWSiteHeader
// }

// export interface IAppState {
//   AppConfig: any;
//   ProcessID: string;
//   Banner: string;
//   HideFlowbar: boolean;
//   ShowThankyouBox: boolean;
//   ShowOrderNumberBox: boolean;
//   HeaderType: SiteHeaderType;
//   OrderSummarySettings: IOrderSummarySettings;
//   InitCustomer: InitCustomerState;
//   Campaign: CampaignState;
//   AlternativeCampaign: CampaignState;
//   MessageScreenData: IMessageScreenData;
//   TimeWindows: TimeWindowsResponse;
// }
@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private historyState = new Array<[string, IAppState]>();
  private appState$ = new BehaviorSubject<IAppState>(null);
  public elctPackage$ = new BehaviorSubject<string>(null);
  get appState(): BehaviorSubject<IAppState> {
    return this.appState$;
  }

  get currentState(): IAppState {
    return this.appState$.value;
  }

  constructor(private storageService: StorageService) {
    this.initState();
  }

  private initState(): void {
    // Todo fix init state
    this.updateState(
      new AppStateAction.OnInitState({
        ...this.currentState,
        InitCustomer: {
          ...this.currentState?.InitCustomer,
          IdentityNumber: this.storageService.getSessionValue('identityNumber')
        },
        OrderSummarySettings: {
          ...this.currentState?.OrderSummarySettings,
          isMobileCollaplsable: true
        },
        Entry: this.storageService.getEntry(),
        Campaign: {}
      })
    );
  }

  updateIdentity(identityNumber: String): void {
    this.updateState(
      new AppStateAction.OnInitState({
        ...this.currentState,
        InitCustomer: {
          ...this.currentState?.InitCustomer,
          IdentityNumber: identityNumber
        }
      })
    );
  }

  updatePhoneNumber(phoneNumber: String): void {
    this.updateState(
      new AppStateAction.OnInitState({
        ...this.currentState,
        InitCustomer: {
          ...this.currentState?.InitCustomer,
          PhoneNumber: phoneNumber
        }
      })
    );
  }

  updateState(action: AppStateAction.Action): void {
    let newState: IAppState;
    switch (action.type) {
      case AppStateAction.ON_INIT_STATE: {
        newState = action.payload;
        break;
      }

      case AppStateAction.ON_LOAD_APP_CONFIG_SUCCESS: {
        newState = {
          ...this.currentState,
          AppConfig: {
            ...action.payload
          }
        };
        break;
      }

      case AppStateAction.ON_LOAD_APP_CONFIG_FAILED: {
        newState = {
          ...this.currentState,
          AppConfig: {
            ...action.payload
          }
        };
        break;
      }
      case AppStateAction.ON_UPDATE_FLOWBAR_INDEX: {
        newState = {
          ...this.currentState,
          FlowbarIndex: action.payload
        };
        break;
      }
      case AppStateAction.ON_LOAD_ORDER_SUCCESS: {
        newState = {
          ...this.currentState,
          OrderCustomer: {
            ...action.payload
          }
        };
        break;
      }
      case AppStateAction.ON_LOAD_ORDER_FAILED: {
        newState = {
          ...this.currentState,
          OrderCustomer: null
        };
        break;
      }
      case AppStateAction.ON_CAMPAIGN_SELECTED: {
        newState = {
          ...this.currentState,
          CampaignSelected: {
            ...action.payload
          }
        };
        break;
      }
      case AppStateAction.ON_LOAD_CAMPAIGN_SUCCESS: {
        newState = {
          ...this.currentState,
          Campaign: {
            ...action.payload
          },
          Banner: action?.payload?.Banner || this.currentState?.Banner
        };
        break;
      }
      case AppStateAction.ON_LOAD_CAMPAIGN_FAILED: {
        newState = {
          ...this.currentState,
          Campaign: {
            ...action.payload
          },
          Banner: action?.payload?.Banner || this.currentState?.Banner
        };
        break;
      }
      case AppStateAction.ON_LOAD_ALTERNATIVE_CAMPAIGN_SUCCESS: {
        newState = {
          ...this.currentState,
          OrderSummarySettings: {
            ...this.currentState.OrderSummarySettings,
            hideSummary: true
          },
          AlternativeCampaign: {
            ...action.payload
          },
          Banner: action?.payload?.Banner || this.currentState?.Banner
        };
        break;
      }
      case AppStateAction.ON_LOAD_ALTERNATIVE_CAMPAIGN_FAILED: {
        newState = {
          ...this.currentState,
          AlternativeCampaign: {
            ...action.payload
          },
          Banner: action?.payload?.Banner || this.currentState?.Banner
        };
        break;
      }
      case AppStateAction.ON_SELECT_ALTERNATIVE_CAMPAIGN_SUCCESS: {
        newState = {
          ...this.currentState,
          OrderSummarySettings: {
            ...this.currentState.OrderSummarySettings,
            hideSummary: false
          },
          Campaign: {
            ...action.payload
          },
          Banner: action?.payload?.Banner || this.currentState?.Banner
        };
        break;
      }
      case AppStateAction.ON_INIT_CUSTOMER_SUCCESS: {
        newState = {
          ...this.currentState,
          InitCustomer: {
            ...action.payload
          },
          ProcessID: action?.payload?.ProcessID || this.currentState?.ProcessID
        };
        break;
      }
      case AppStateAction.ON_INIT_CUSTOMER_FAILED: {
        newState = {
          ...this.currentState,
          InitCustomer: {
            ...action.payload
          },
          ProcessID: action?.payload?.ProcessID || this.currentState?.ProcessID
        };
        break;
      }
      case AppStateAction.ON_LOAD_TIME_WINDOWS_SUCCESS: {
        newState = {
          ...this.currentState,
          TimeWindows: {
            ...action?.payload
          }
        };
        break;
      }
      case AppStateAction.ON_LOAD_TIME_WINDOWS_FAILED: {
        newState = {
          ...this.currentState,
          TimeWindows: {
            ...action?.payload
          }
        };
        break;
      }
      case AppStateAction.ON_ROUTE_TO_MESSAGE_SCREEN: {
        newState = {
          ...this.currentState,
          MessageScreenData: {
            ...action?.payload
          }
        };
        break;
      }
      case AppStateAction.Show_Order_Open_OR_Close: {
        newState = {
          ...this.currentState,
          ShowOrderOpen: action?.payload
        };
        break;
      }
      case AppStateAction.ON_ROUTE_TO_SUCCESS_PAGE: {
        newState = {
          ...this.currentState,
          HeaderType: SiteHeaderType.WWWSiteHeader,
          HideFlowbar: true,
          ShowOrderNumberBox: true,
          ShowThankyouBox: true,
          OrderSummarySettings: {
            ...action?.payload
          }
        };
        break;
      }
      case AppStateAction.ON_UPDATE_ENTRY: {
        newState = {
          ...this.currentState,
          Entry: action?.payload
        };
        break;
      }
      case AppStateAction.ON_LOAD_PAYMENT_RESPONSE: {
        newState = {
          ...this.currentState,
          PaymentResponse: action?.payload
        };
        break;
      }
    }

    this.appState$.next(newState);
    this.historyState.push([action.type, this.currentState]);

    this.updateReduxExtention(action);

    // console.log('-------------------------------------------------------------------------------------------------');
    // console.log('%c' + action.type, 'font-weight: bold; font-size: 16px; text-decoration: underline;');
    // console.log(new Date().toLocaleTimeString());
    // console.log('currentState:', this.currentState);
    // console.log('-------------------------------------------------------------------------------------------------');
    // console.log('\n\n');

    // if (!environment.isDev) {
    // this.sendHttpLog(action.type, action.payload, newState);
    // }
    //to do: enable logger
    //this.bezeqLoggerService.setLogInfo(this.currentState, action.type);
  }

  updateReduxExtention(action: AppStateAction.Action): void {
    reduxExtentionHelper.sendAction(action.type, this.currentState);
  }
}
